export const Token = '4D006D0B3FF2019759A6FD719AE8B291E2B2A4935F0CC42D72534C494C95AAFD';
export const MAX_COOKIE_DATE = 90; 